exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td.location {\r\n    color: #018E42;\r\n    transition: linear 0.1s;\r\n}\r\n\r\n    td.location:hover {\r\n        color: #FC6119;\r\n        cursor: pointer;\r\n        transition: linear 0.1s;\r\n    }\r\n\r\ntr.active-row {\r\n    background-color: #F1C40F !important;\r\n    transition: linear 0.1s;\r\n}\r\n\r\n    tr.active-row td {\r\n        font-weight: 600;\r\n        font-size: 15px;\r\n        transition: linear 0.1s;\r\n    }\r\n\r\ndiv#location-modal div.modal-dialog {\r\n    width: 95%;\r\n    height: 95%;\r\n    margin: 0;\r\n    padding: 0;\r\n    display: block;\r\n    margin: auto;\r\n    margin-top: 50px;\r\n}\r\n\r\ndiv#location-modal div.modal-content {\r\n    height: 95%;\r\n    border-radius: 0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/case/list/case.component.css
// module id = 980
// module chunks = 1